import { AudioBackupAndRecoveryStatus } from "./RecoveringActions";
import { BootError, BootErrors } from "../BootErrors";
import { IRealTimeTranscriptionConnection } from "../../backend/interfaces/IRealTimeTranscriptionConnection";
import { CreateDefaultRealTimeTranscriptionConnection } from "../../backend/RealTimeTranscriptionConnectionFactory";
import { TranscriptionRoutePathNames } from "../routes";


/** 
 * An uninitialized audio backup is usually a consequence of a failure to open an indexeddb database
 * This usually happens if the user has blocked third-party cookies or is out of disk-space
 * In either of these cases, fetching an auth token would also currently fail - since the authAPI relies on localStorage being available
 * Allowing the user to proceed from this point will allow them to generate a recording/select a file to transcribe, but they would 
 * fail uploading to OneDrive. 
 * Whereas, we need OneDrive for both recording and the file upload scenarios. So, we will fail fast here - until the auth reliance on 
 * localStorage gets fixed
 * (auth team says this should be fixed around Oct, 2020)
 * */
export function NavigateToLandingPageAfterAudioBackupCheck(backupAndState: AudioBackupAndRecoveryStatus, history: any) {
    if (backupAndState.audioBackup == null || !backupAndState.audioBackup.IsInitializedSuccessfully()) {
        throw new BootError(BootErrors.IndexeddbFailedToOpen, "Failed to open indexeddb, which implies auth failures later.");
    } else {
        // We want to create a transcription connection here to avoid paying the initialization price later, so it improves the "time to input" metric.
        const realTimeTranscriptionConnection: IRealTimeTranscriptionConnection = CreateDefaultRealTimeTranscriptionConnection();
        history.replace(TranscriptionRoutePathNames.Landing, {realTimeTranscriptionConnection, audioBackup: backupAndState.audioBackup});
    }  
}